import { InventoryLocationListPage } from "@/features/inventory-location/pages/InventoryLocationListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-location/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["inventory_location.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryLocationListPage,
});
